import { useCallback, useMemo } from 'react';

import { usePlexRoute } from '../usePlexRoute';

type Value = { permalink: string; commentsVisible: boolean } | null;
type Setter = (v: Value) => void;

// TODO: do we need path?
export function useSelectedPlexPost(path?: string): [Value, Setter] {
  const [plexRoute, updatePlexRoute] = usePlexRoute();

  const selectedPlexPost = useMemo(
    () =>
      plexRoute?.selectedItem?.type === 'post'
        ? {
            permalink: plexRoute.selectedItem.permalink,
            commentsVisible: !!plexRoute.selectedItem.commentsVisible,
          }
        : null,
    [plexRoute]
  );

  const setSelectedPlexPost = useCallback(
    (selectedPlexPost: Value): void => {
      if (selectedPlexPost != null) {
        const { permalink, commentsVisible } = selectedPlexPost;
        updatePlexRoute({ selectedItem: { type: 'post', permalink, commentsVisible } }, 'push');
      } else {
        updatePlexRoute({ selectedItem: undefined }, 'push');
      }
    },
    [updatePlexRoute]
  );

  return [selectedPlexPost, setSelectedPlexPost];
}
